









































import { Component, Prop } from "vue-property-decorator"
import Super from "@/pv4-super-class"

@Component({})
export default class ModalHeader extends Super {
  @Prop({ type: String, required: false, default: "" }) label!: any
  @Prop({ type: String, required: false, default: "" }) icon!: any
  @Prop({ type: Boolean, required: false, default: true }) showBack!: any
  @Prop({ type: String, required: false, default: "Save" }) saveLabel!: any
  @Prop({ type: String, required: false, default: "Saved" }) savedLabel: any
  @Prop({ type: Boolean, required: false, default: false }) saved!: any

  save() {
    this.$emit("save")
  }

  back() {
    if (this.saved) {
      this.$emit("back")
      return
    }

    let params = {
      message:
        "Are you sure you want to go back? Any unsaved changes will be lost.",
      trapFocus: true,
      onConfirm: () => this.$emit("back")
    }

    this.$buefy.dialog.confirm(params)
  }
}
